import { Middleware } from '@reduxjs/toolkit';
import { ModalWindowTypes } from '../utils/@globalTypes';
import { setTotalPrice } from './reducers/bookingSlice';

export const cleanupMiddleware: Middleware = (store) => (next) => (action) => {
  const result = next(action);
  
  // Проверяем, является ли действие закрытием модального окна
  if (action.type === 'pageSlice/setModalWindowData' || 
      action.type?.endsWith('/setModalWindowData')) {
    if (action.payload?.type === ModalWindowTypes.CLOSE) {
      store.dispatch(setTotalPrice(null));
    }
  }
  
  return result;  
};